import React, { ReactNode } from "react";
import Grid from "onnit-ui/lib/module/grid/12/Grid";
import Box, { BoxProps } from "onnit-ui/lib/box/Box";
import Text, { Sup } from "onnit-ui/lib/text";
import Dash from "onnit-ui/lib/icon/Dash";

interface Props extends BoxProps {
    primaryColor?: string;
    description?: ReactNode;
}

export default function NewMoodIngredientList({ primaryColor = "#5D5BA8", description, ...rest }: Props) {
    return (
        <Grid px={[4, 4, 5]} {...rest}>
            <Box gridColumn={["1 / -1", "1 / -1", "1 / -1", "2 / span 8"]} mb={[7, 8, 8, 10]}>
                <Text
                    as="h2"
                    typeStyle="headlineHero01"
                    color={primaryColor}
                    fontSize={[6, 6, 6, 12, 12, 12]}
                    mb={[4, 4, 6]}
                >
                    Key Ingredients
                </Text>
                {description}
            </Box>
            <Box gridColumn={["1 / -1", "1 / -1", "1 / -1", "3 / span 8"]}>
                <Box mb={[6, 6, 8]}>
                    <Dash color={primaryColor} mb={[3, 3, 5]} width={["80px", "100px", "130px"]} />
                    <Text as="h3" color={primaryColor} typeStyle="copyHero01" mb={[1, 2, 3]}>
                        5-HTP
                    </Text>
                    <Text as="p" typeStyle="copyHero02" color="grays.4">
                        The direct precursor and metabolic intermediate of serotonin, 5-HTP is one of the best nutrients
                        to optimize the body’s natural supply of serotonin.
                        <Sup />
                    </Text>
                </Box>
                <Box mb={[6, 6, 8]}>
                    <Dash color={primaryColor} mb={[3, 3, 5]} width={["80px", "100px", "130px"]} />
                    <Text as="h3" color={primaryColor} typeStyle="copyHero01" mb={[1, 2, 3]}>
                        Magnesium
                    </Text>
                    <Text as="p" typeStyle="copyHero02" color="grays.4">
                        Magnesium is needed for hundreds of your body’s basic functions, including supporting your heart
                        and nervous system health, and maintaining blood pressure levels.
                        <Sup /> Supporting a sense of muscular and physical calm, magnesium is commonly used to combat
                        occasional stress and restlessness.
                        <Sup />
                    </Text>
                </Box>
                <Box mb={[6, 6, 8]}>
                    <Dash color={primaryColor} mb={[3, 3, 5]} width={["80px", "100px", "130px"]} />
                    <Text as="h3" color={primaryColor} typeStyle="copyHero01" mb={[1, 2, 3]}>
                        Tryptophan
                    </Text>
                    <Text as="p" typeStyle="copyHero02" color="grays.4">
                        L-Tryptophan is an essential amino acid found naturally in proteins. It is the building block
                        for 5-HTP, the direct precursor to serotonin. Furthermore, tryptophan is also able to convert to
                        melatonin, which aids sleep.
                        <Sup />
                    </Text>
                </Box>
                <Box mb={[6, 6, 8]}>
                    <Dash color={primaryColor} mb={[3, 3, 5]} width={["80px", "100px", "130px"]} />
                    <Text as="h3" color={primaryColor} typeStyle="copyHero01" mb={[1, 2, 3]}>
                        Vitamin B-3 (Niacin)
                    </Text>
                    <Text as="p" typeStyle="copyHero02" color="grays.4">
                        Common in meat and fish, this B vitamin plays a crucial role in the synthesis of serotonin.{" "}
                        <Sup />
                    </Text>
                </Box>
                <Box>
                    <Dash color={primaryColor} mb={[3, 3, 5]} width={["80px", "100px", "130px"]} />
                    <Text as="h3" color={primaryColor} typeStyle="copyHero01" mb={[1, 2, 3]}>
                        Vitamin B-6
                    </Text>
                    <Text as="p" typeStyle="copyHero02" color="grays.4">
                        Pyridoxine (Vitamin B-6) is one of the body’s busiest vitamins, involved in an estimated 101
                        chemical reactions. One of its primary tasks is to aid in the manufacturing of amino acids and
                        neurotransmitters, including serotonin.
                        <Sup />
                    </Text>
                </Box>
            </Box>
        </Grid>
    );
}
